import React, { useState } from 'react'
import { t } from '@lingui/core/macro'
import styles from './CurrencySelector.module.css'

interface Currency {
    code: string
    name: string
    symbol: string
}

const getCurrencies = () => [
    { code: 'USD', name: t`Доллар США`, symbol: '$' },
    { code: 'EUR', name: t`Евро`, symbol: '€' },
    { code: 'GBP', name: t`Фунт стерлингов`, symbol: '£' },
    { code: 'RUB', name: t`Российский рубль`, symbol: '₽' },
    { code: 'CNY', name: t`Китайский юань`, symbol: '¥' },
    { code: 'JPY', name: t`Японская иена`, symbol: '¥' },
    { code: 'BRL', name: t`Бразильский реал`, symbol: 'R$' },
] as Currency[]

interface CurrencySelectorProps {
    value: string
    onChange: (currency: string) => void
}

const CurrencySelector = ({ value, onChange }: CurrencySelectorProps) => {
    const [isOpen, setIsOpen] = useState(false)

    const currentCurrency = getCurrencies().find(curr => curr.code === value)

    if (!currentCurrency) {
        throw new Error(`Undefined currency code ${value}`)
    }

    const handleCurrencySelect = (currencyCode: string) => {
        onChange(currencyCode)
        setIsOpen(false)
    }

    return (
        <div className={styles.currencySelector}>
            <button className={styles.currentCurrency} onClick={() => setIsOpen(!isOpen)}>
                <span className={styles.currencyCode}>{currentCurrency.code}</span>
                <span className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`}>▼</span>
            </button>

            {isOpen && (
                <div className={styles.dropdown}>
                    {getCurrencies().map((currency) => (
                        <button
                            key={currency.code}
                            className={`${styles.currencyOption} ${currency.code === value ? styles.active : ''}`}
                            onClick={() => handleCurrencySelect(currency.code)}
                        >
                            <span className={styles.currencyInfo}>
                                <span className={styles.code}>{currency.code}</span>
                                <span className={styles.symbol}>{currency.symbol}</span>
                            </span>
                            <span className={styles.name}>{currency.name}</span>
                        </button>
                    ))}
                </div>
            )}

            {isOpen && <div className={styles.backdrop} onClick={() => setIsOpen(false)}/>}
        </div>
    )
}

export default CurrencySelector
